<template>
  <div id="app" class="min-h-screen relative">
    <main class="container mx-auto px-4 py-6 relative z-10 pointer-events-none">
      <transition name="fade" mode="out-in">
        <div class="pointer-events-auto">
          <a v-if="$route.name !== 'post'" class="dongle absolute top-6 right-6 px-4 py-2 rounded-full text-3xl bg-white text-blue-600 box-shadow hover:scale-105 transition-transform" target="_blank" href="http://before.theageingsea.net/">우죽은 감태</a>
          <router-view />
        </div>
      </transition>
    </main>
    <Map />
  </div>
</template>

<script>
import Map from '@/components/Map'

export default {
  components: { Map }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition-property: opacity;
  transition-duration: .25s;
}

.fade-enter-active {
  transition-delay: .25s;
}

.fade-enter, .fade-leave-active {
  opacity: 0
}

</style>
